import { useCallback, useEffect, useRef } from "react";

const buildHistoryToken = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

const getHistoryState = () =>
  window.history.state && typeof window.history.state === "object"
    ? window.history.state
    : {};

export default function useModalBackNavigation({
  isOpen,
  onClose,
  stateKey,
  enabled = true,
}) {
  const tokenRef = useRef("");
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") {
      return undefined;
    }

    if (isOpen && !tokenRef.current) {
      const token = buildHistoryToken();
      window.history.pushState(
        {
          ...getHistoryState(),
          [stateKey]: token,
        },
        document.title,
        window.location.href
      );
      tokenRef.current = token;
    }

    if (!isOpen && tokenRef.current) {
      const token = tokenRef.current;
      tokenRef.current = "";
      if (window.history.state?.[stateKey] === token) {
        window.history.back();
      }
    }

    const handlePopState = (event) => {
      const token = tokenRef.current;
      if (!token || event.state?.[stateKey] === token) return;

      tokenRef.current = "";
      onCloseRef.current?.();
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [enabled, isOpen, stateKey]);

  return useCallback(() => {
    const token = tokenRef.current;
    tokenRef.current = "";
    onCloseRef.current?.();

    if (
      enabled &&
      typeof window !== "undefined" &&
      token &&
      window.history.state?.[stateKey] === token
    ) {
      window.history.back();
    }
  }, [enabled, stateKey]);
}
